import moment from 'moment';
import {
  BI_BASE_API_URL,
  BI_GET_YEARS_ENDPOINT,
  BI_GET_PATIENTS_GROUPS_ENDPOINT,
} from '../constants/filterConstants';
import { storeFilterOptions } from '../redux/actions/filterAction';
import store from '../redux/store';
import httpService from './httpService';

const filterService = () => {
  // GET - Options de ano
  const getYears = async ({ patientGroupItemCode }) => {
    const { get } = httpService();
    const params = {
      PatientGroupItemCode: patientGroupItemCode,
    };

    const result = await get({
      url: BI_BASE_API_URL + BI_GET_YEARS_ENDPOINT,
      data: params,
    });

    return result;
  };

  // GET - Options de ano
  const getPatientsGroups = async () => {
    const { get } = httpService();
    const params = null;

    const result = await get({
      url: BI_BASE_API_URL + BI_GET_PATIENTS_GROUPS_ENDPOINT,
      data: params,
    });

    return result;
  };

  const getYearsByPatientGroup = async (
    culture, filterCache, filterPatientGroupSelected,
  ) => {
    const currentUserLanguage = localStorage.getItem('bi.userLanguage');
    const timeNow = new Date().getTime();
    const cacheTimeNow = moment(timeNow).format('YYYY-MM-DD hh:mm:ss');
    const patientsGroupsCache = filterCache.patientsGroups;
    const yearsCache = filterCache.years;
    let filterYearsOptions = [];

    const params = {
      patientGroupItemCode: filterPatientGroupSelected,
    };

    const yearsResponseJSON = await getYears(params);
    const yearsList = yearsResponseJSON ? yearsResponseJSON.data.response : null;

    // Transforma retorno para o padrão esperado pelo react-select
    if (yearsList) {
      filterYearsOptions = yearsList ? yearsList.map((option) => { // (option, index)
        const optionsList = {
          value: option, // index
          label: option,
        };

        return optionsList;
      }) : null;

      // Organiza em ordem decrescente os anos
      const filterYearsOptionsDescending = filterYearsOptions.sort(
        (a, b) => parseFloat(b.value) - parseFloat(a.value),
      );

      const newFilterCache = {
        ...filterCache,
        patientsGroups: {
          ...patientsGroupsCache,
        },
        years: {
          ...yearsCache,
          [culture || currentUserLanguage]: filterYearsOptionsDescending,
        },
      };

      // Atualiza objeto de filtro na store (cache)
      store.dispatch(storeFilterOptions(newFilterCache, cacheTimeNow));
      return newFilterCache.years[culture || currentUserLanguage];
    }

    return yearsCache;
  };

  const getInitialBenchmarkingFiltersData = async (culture, filterCache, lastCacheTime) => {
    const currentUserLanguage = localStorage.getItem('bi.userLanguage');
    const timeNow = new Date().getTime();
    const cacheTimeNow = moment(timeNow).format('YYYY-MM-DD hh:mm:ss');
    const lastCacheTimeSaved = lastCacheTime ? moment(lastCacheTime).format('YYYY-MM-DD hh:mm:ss') : null;
    const expiresCacheTime = lastCacheTime ? moment(lastCacheTime).add(1, 'hours').format('YYYY-MM-DD hh:mm:ss') : null;
    const patientsGroupsCache = filterCache.patientsGroups;
    const yearsCache = filterCache.years;

    let filterPatientsGroupsOptions = [];
    let filterYearsOptions = [];

    // Verifica os dados em cache para fazer ou não a requisição da tradução no idioma atual
    // Se já houver no cache traduções do idioma selecionado, não é feita nova requisição
    // Mas se feita após 1 hora desde o último cache salvo, é feita outra requisição
    if (
      filterCache === []
    || filterCache === null
    || !filterCache.patientsGroups
    || !filterCache.patientsGroups[culture]
    || !filterCache.years
    || !filterCache.years[culture]
    || lastCacheTimeSaved === null
    || expiresCacheTime <= cacheTimeNow
    ) {
      const patientsGroupsResponseJSON = await getPatientsGroups();
      const patientsGroupsList = patientsGroupsResponseJSON
        ? patientsGroupsResponseJSON.data.response : null;

      const params = {
        patientGroupItemCode: filterCache
         && filterCache.patientsGroups
         && filterCache.patientsGroups[culture]
          ? filterCache.patientsGroups[culture] : 0,
      };

      const yearsResponseJSON = await getYears(params);
      const yearsList = yearsResponseJSON ? yearsResponseJSON.data.response : null;

      // Transforma retorno para o padrão esperado pelo react-select
      if (patientsGroupsList || yearsList) {
        filterPatientsGroupsOptions = patientsGroupsList ? patientsGroupsList.map((option) => {
          const optionsList = {
            value: option.code,
            label: option.name,
          };

          return optionsList;
        }) : null;

        filterYearsOptions = yearsList ? yearsList.map((option) => { // (option, index)
          const optionsList = {
            value: option, // index
            label: option,
          };

          return optionsList;
        }) : null;

        // Organiza em ordem decrescente os anos
        const filterYearsOptionsDescending = filterYearsOptions.sort(
          (a, b) => parseFloat(b.value) - parseFloat(a.value),
        );

        const newFilterCache = {
          ...filterCache,
          patientsGroups: {
            ...patientsGroupsCache,
            [culture || currentUserLanguage]: filterPatientsGroupsOptions,
          },
          years: {
            ...yearsCache,
            [culture || currentUserLanguage]: filterYearsOptionsDescending,
          },
        };

        // Atualiza objeto de filtro na store (cache)
        store.dispatch(storeFilterOptions(newFilterCache, cacheTimeNow));

        return newFilterCache;
      }
    }

    return filterCache;
  };

  return {
    getYears,
    getPatientsGroups,
    getYearsByPatientGroup,
    getInitialBenchmarkingFiltersData,
  };
};

export default filterService;
